import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

import { AnalyticsEvents } from '../../../enums/AnalyticsEvents';
import { useAnalytics } from '../../../hooks/useAnalytics';
import useGlobalStyles from '../../../hooks/useGlobalStyles';
import Menu from '../Menu/Menu';
import StyledPage from './StyledPage';

interface PageProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  withBackground?: boolean;
  hideMainMenu?: boolean;
}

const Page = ({
  children,
  title,
  description,
  withBackground = false,
  hideMainMenu = false,
}: PageProps): JSX.Element => {
  const location = useLocation();
  const { track } = useAnalytics();

  useGlobalStyles('nav#main-menu', 'hide-main-menu', hideMainMenu);
  useGlobalStyles('main', 'circular-gradient-background', withBackground);

  useEffect(() => {
    track(AnalyticsEvents.PAGE_VIEWED, { page: location.pathname });
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={`localhost:3000/${location.pathname}`} />
      </Helmet>
      <Menu>
        <StyledPage>
          {withBackground ? (
            <Box
              sx={{
                width: '100%',
                maxWidth: 1200,
                mx: 'auto',
                my: { xs: 1.5, md: 2.5 },
                p: { xs: 1.25, md: 2 },
                bgcolor: '#FFFFFF',
                borderRadius: { xs: 3, md: 4 },
                border: '1px solid rgba(15, 23, 42, 0.06)',
                boxShadow: '0px 10px 28px rgba(15, 23, 42, 0.08)',
              }}
            >
              {children}
            </Box>
          ) : (
            children
          )}
        </StyledPage>
      </Menu>
    </>
  );
};

export default Page;
